import React from "react";
import styles from "./styles";
import LottieWebPlayer from "./LottieWebPlayer";

const closeWhiteJson = require("./assets/jsons/closeWhite.json");
const videoObjectJson = require("./assets/jsons/videoObject.json");
const audioStoriesJson = require("./assets/jsons/Audio_stories.json");
const bouncyBagJson = require("./assets/jsons/bouncyBag.json");
const raysBgImg = require("./assets/images/rays.png");

interface MagicBackpackModalProps {
  onClose: () => void;
  onVideoPress: () => void;
  onAudioPress: () => void;
}

const MagicBackpackModal: React.FC<MagicBackpackModalProps> = ({
  onClose,
  onVideoPress,
  onAudioPress,
}) => {
  return (
    <div style={{ ...styles.backpackOverlay, position: "fixed" }}>
      {/* Rays — full width, top portion */}
      <div
        style={{
          ...styles.backpackBgWrapper,
          backgroundImage: `url(${raysBgImg})`,
        }}
      />

      {/* Close button — top-right corner */}
      <button
        style={styles.backpackCloseBtn}
        onClick={onClose}
        aria-label="Close backpack"
      >
        <LottieWebPlayer
          source={closeWhiteJson}
          style={{ width: 40, height: 40 }}
          autoPlay
          loop={false}
        />
      </button>

      {/* Video + Audio icons — floated over the rays */}
      <div style={styles.backpackObjectsRow}>
        <button
          style={styles.backpackObjectBtn}
          onClick={onVideoPress}
          aria-label="Video stories"
        >
          <LottieWebPlayer
            source={videoObjectJson}
            style={styles.backpackObjectLottie}
            autoPlay
            loop
          />
        </button>
        <button
          style={styles.backpackObjectBtn}
          onClick={onAudioPress}
          aria-label="Audio stories"
        >
          <LottieWebPlayer
            source={audioStoriesJson}
            style={styles.backpackObjectLottie}
            autoPlay
            loop
          />
        </button>
      </div>

      {/* Bag — bottom-center, peeking up */}
      <div style={styles.backpackBagWrapper}>
        <LottieWebPlayer
          source={bouncyBagJson}
          style={styles.backpackBagLottie}
          autoPlay
          loop
        />
      </div>
    </div>
  );
};

export default MagicBackpackModal;
